<template>
  <v-app>
    <v-row v-if="!isLoading && accessError" cols="12" justify="center">
      <v-alert type="error" class="mx-auto col-6" style="height: 60px; margin-top:50px;">
        {{ username }} no tiene permitido el acceso
        <v-btn color="#222" @click="logout" text float="right">Cerrar sesión</v-btn>
      </v-alert>
    </v-row>

    <v-app-bar app clipped-left v-if="!isLoading && !accessError" style="background-color: #FFFFFF;">
      <!--<v-app-bar-nav-icon dark  @click="drawer = !drawer"></v-app-bar-nav-icon>-->

      <v-toolbar-items>
        <img src="img/logo-icoev-actual.png"/>
        <span style="font-size: 1.3em; color: #065535; padding: 15px; font-weight: 600;">Registro de documentos</span>
      </v-toolbar-items>

      <!--<v-toolbar-title class="light--text hidden-sm-and-down">icoev-docs Admin</v-toolbar-title>-->

      <v-spacer></v-spacer>

      <span class="primary--text hidden-sm-and-down" style="margin-right: 10px; font-size: .9em;"> {{ username }} </span>

    <v-menu bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="bg-btn"
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="primary--text">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item  @click="logout()">
          <v-list-item-title>Cerrar sesión</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

  </v-app-bar>

  <v-row v-if="isLoading" cols="12" justify="center" style="margin-top:60px">
    <v-col class="mx-auto" cols="12">
      <v-skeleton-loader type="card" class="mx-auto" max-width="90%"/>
    </v-col>
  </v-row>

  <!-- Sizes your content based upon application components -->
  <v-main v-if="!isLoading && !accessError">

    <!-- Provides the application the proper gutter -->
    <v-container fluid style="background-color: #F0F4F0; height: 100vh;">

      <!-- If using vue-router -->
      <keep-alive>
      <router-view></router-view>
      </keep-alive>
    </v-container>
  </v-main>

  <v-footer app>
    <!-- -->
  </v-footer>
</v-app>
</template>

<script>
// eslint-disable-next-line no-unused-vars
//import styles from './assets/App.css'
import BaseModule from './components/common/BaseModule'

export default {
  name: 'App',
  mixins: [BaseModule],
  components: {
  },

  data () {
      return {
        drawer: true,
        isLoading: true,
        accessError: false,
        right: null,
      }
    },
    computed: {
      username() {
        return this.$store.state.icoev.profile.username;
      },
      userIsAdmin() {
        return true;//this.$store.state.icoev.user.isAdmin;
      },
      userIsSuperAdmin() {
        return false;//this.$store.state.icoev.user.isSuperAdmin;
      },
    },
    mounted: function () {
      this.isLoading=false;
      /*this.$nextTick(function () {
        this.isLoading=true;
        this.getSessionInfo(0, 
          data => {
					this.$store.commit('icoev/setDocuments', data);
          this.isLoading=false;
          },
          () => {
            this.isLoading=false;
            this.accessError=true;
          });
      });*/
    },
  methods: {
    logout: function() {
        // eslint-disable-next-line no-undef
        kc_logout();
    },
  },
};
</script>
